import { useEffect, useState } from 'react';

/** Comme `useMediaQuery` de Mantine, mais sur la fenêtre qui porte le nœud : le canvas Puck (iframe) simule le téléphone par sa largeur. */
export function useOwnerMediaQuery(ref, query) {
  const [matches, setMatches] = useState(false);
  useEffect(() => {
    const media = ref.current?.ownerDocument.defaultView?.matchMedia?.(query);
    if (!media) return undefined;
    const update = () => setMatches(media.matches);
    update();
    media.addEventListener('change', update);
    return () => media.removeEventListener('change', update);
  }, [ref, query]);
  return matches;
}
